import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { AppConstants } from "../../constants/app-constants";
import { Observable, BehaviorSubject } from "rxjs";



@Injectable({
    providedIn: 'root'
})
export class UserService {
    language: string;

    constructor(private http: HttpClient) {
    }


    // pass discard dialog open - true/false
    private preventData = new BehaviorSubject<any>('');
    preventDataastring$ = this.preventData.asObservable();

    setPreventData(data: any) {
        this.preventData.next(data);
    }

    getPreventData(): Observable<any> {
        return this.preventData.asObservable();
    }

    // local storage clear observable
    private clearData = new BehaviorSubject<any>('');
    clearDataastring$ = this.clearData.asObservable();

    setClearLocalStorage(data: any) {
        this.clearData.next(data);
    }

    getClearLocalStorage(): Observable<any> {
        return this.clearData.asObservable();
    }
    // Get Disalog box is already opened
    private isAlreadyOpened = new BehaviorSubject<any>('');
    isAlreadyOpenedString$ = this.isAlreadyOpened.asObservable();

    setSessionExpiredDialogOpened(data: any) {
        this.isAlreadyOpened.next(data);
    }

    // Themes
    private themesData = new BehaviorSubject<any>('');
    themesDatastring$ = this.themesData.asObservable();

    setDynamicTheme(data: any) {
        this.themesData.next(data);
    }
    // isSyncCheckApi
    private isSyncCheckApi = new BehaviorSubject<any>('');
    isSyncCheckApi$ = this.isSyncCheckApi.asObservable();

    setSyncCheckApi(data: any) {
        this.isSyncCheckApi.next(data);
    }

    getDynamicTheme(): Observable<any> {
        return this.themesData.asObservable();
    }

    // creates a new user and creates a session for that user
    signUp(data) {
        const url1 = environment.SERVER_URL + AppConstants.SIGNUP;
        return this.http.post(url1, data);
    }

    // creates a otp for the user to signup
    generateAndSendOtpForSignup(data) {
        var body = {
            "emailid": data.email,
            "orgid": data.orgid
        };
        const url1 = environment.SERVER_URL + AppConstants.GENERATE_AND_SEND_OTP_FOR_SIGNUP;
        return this.http.post(url1, body);
    }

    // creates a otp for the user to login
    generateAndSendOtpForLogin(data) {
        var body = {
            "emailid": data.email,
            "orgid": data.orgid
        };
        const url1 = environment.SERVER_URL + AppConstants.GENERATE_AND_SEND_OTP_FOR_LOGIN;
        return this.http.post(url1, body);
    }

    // Verifies if the otp is valid or not
    validateOtp(data) {
        var body = {
            "emailid": data.email,
            "otp": data.otp,
            "orgid": '1'
        };
        const url1 = environment.SERVER_URL + AppConstants.VALIDATE_OTP;
        return this.http.post(url1, body);
    }

    // creates a new seesion for existing user
    signInWithPassword(data) {
        var body = {
            "password": data.password,
            "username": data.username
        }
        const url1 = environment.SERVER_URL + AppConstants.SIGNIN;
        return this.http.post(url1, body);

    }

    // creates a new seesion for existing user
    signInWithOTP(data) {
        var body = {
            "username": data.username,
            "orgid": "1",
            "otp": data.otp.toString()
        }
        const url1 = environment.SERVER_URL + AppConstants.SIGNIN_WITH_OTP;
        return this.http.post(url1, body);

    }

    // check if the given password matches the existing one
    checkPassword(data) {
        const url1 = environment.SERVER_URL + AppConstants.CHECK_PASSWORD;
        return this.http.put(url1, data);

    }

    // check if the given mail id is a valid user
    checkIfUserExists(data) {
        const url1 = environment.SERVER_URL + AppConstants.CHECK_IF_USER_EXISTS;
        return this.http.get(url1, {
            params: {
                emailid: data
            }
        });

    }


    getOrganizationById(orgid, tenantidarray) {
        const url = environment.SERVER_URL + AppConstants.ORGANIZATION_DETAILS;
        const headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.get(url,
            {
                params: {
                    orgid: orgid,
                    tenantid: tenantidarray
                }
            });
    }

    getOrgbasedForm(orgid) {
        const url = environment.SERVER_URL + AppConstants.ORGBASEDFORM;
        return this.http.get(url, {
            params: {
                orgid: orgid,
                // tenantid: tenantid
            }
        });
    }

    // triggers mail with temp password
    forgotPassword(data) {
        var body = {
            "username": data.username,
            "password": data.password
        }
        const url1 = environment.SERVER_URL + AppConstants.FORGOT_PASSWORD;
        return this.http.get(url1,
            {
                params: body
            }
        );
    }

    // changes the current passowrd with new one
    changePassword(data) {
        const url1 = environment.SERVER_URL + AppConstants.CHANGE_PASSWORD;
        return this.http.put(url1, data);
    }

    // logs out of the account
    logout(accessTokenJti) {
        const url1 = environment.SERVER_URL + AppConstants.LOGOUT;
        return this.http.get(url1,
            {
                params: {
                    accesstokenjti: accessTokenJti.toString(),
                    orgid: '1'
                }
            }
        );
    }

    // removes the invalid token
    discardInvalidTokens(accessTokenJti) {
        const url1 = environment.SERVER_URL + AppConstants.DISCARD_INVALID_TOKENS;
        return this.http.get(url1,
            {
                params: {
                    accesstokenjti: accessTokenJti.toString(),
                    orgid: '1'
                }
            }
        );
    }

    private logoutInvalidCurrentUser = new BehaviorSubject<any>('');
    logoutInvalidCurrentUserObservable$ = this.logoutInvalidCurrentUser.asObservable();

    // automatically logs out the invalid user
    logoutInvalidUser() {
        this.logoutInvalidCurrentUser.next(true);
    }

    // observable for automatically logging out the invalid user
    logoutInvalidUserObservable(): Observable<any> {
        return this.logoutInvalidCurrentUser.asObservable();
    }


    // Function to translate text
    // translateToArabic(element, apiKey, targetLanguage) {
    //     const originalText = element.textContent; // Store the original text
    //     const apiUrl = `https://translation.googleapis.com/language/translate/v2?key=${apiKey}&q=${originalText}&target=${targetLanguage}`;

    //     return fetch(apiUrl)
    //         .then(response => {
    //             if (!response.ok) {
    //                 throw new Error(`HTTP error! Status: ${response.status}`);
    //             }
    //             return response.json();
    //         })
    //         .then(data => {
    //             const translatedText = data.data.translations[0].translatedText;
    //             element.dataset.originalText = originalText; // Store the original text as a data attribute
    //             element.textContent = translatedText; // Update the element with translated text
    //         })
    //         .catch(error => {
    //             console.error('Error:', error);
    //         });
    // }

    // Function to revert text back to original
    // revertToOriginal(element) {
    //     const originalText = element.dataset.originalText; // Get the original text from the data attribute
    //     if (originalText) {
    //         element.textContent = originalText; // Revert to original text
    //         delete element.dataset.originalText; // Remove the data attribute
    //     }
    // }

    // translate() {
    //     // // Example usage:
    //     // const apiKey = 'AIzaSyC-9VmQy_UKfv2yHAjdOIhw93rDDrz8EtM';
    //     // const targetLanguage = 'ar'; // Target language code (e.g., 'es' for Spanish)
    //     // const elementsToTranslate = document.querySelectorAll('#translate');

    //     // // Translate button click event
    //     // elementsToTranslate.forEach((element: any) => {
    //     //     if (!element.dataset.originalText) {
    //     //         // If not already translated, translate the text
    //     //         this.translateToArabic(element, apiKey, targetLanguage);
    //     //     }
    //     // });
    // }

    // original() {
    //     // const elementsToTranslate = document.querySelectorAll('#translate');
    //     // // Revert button click event
    //     // elementsToTranslate.forEach(element => {
    //     //     // Revert the text for all elements
    //     //     this.revertToOriginal(element);
    //     // });
    // }

    changelanguage() {
        this.language = sessionStorage.getItem('currentlanguage');
        setTimeout(() => {
            if (this.language === 'ar') {
                // this.translate();
                this.setDynamicTheme('icrisat');
            } else {
                // this.original();
                this.setDynamicTheme('default');
            }
        }, 1000)
    }
    private isProfileEditActive = new BehaviorSubject<any>('');
    isProfileEditActive$ = this.isProfileEditActive.asObservable();

    // automatically logs out the invalid user
    isCandProfileEditActive(isactive) {
        this.isProfileEditActive.next(isactive);
    }

    private isLanguageActive = new BehaviorSubject<any>('');
    isLanguageActive$ = this.isLanguageActive.asObservable();

    setLanguageButtonVisiblity(isactive) {
        this.isLanguageActive.next(isactive);
    }

    private isProfileEditCancel = new BehaviorSubject<any>('');
    isProfileEditCancel$ = this.isProfileEditCancel.asObservable();
    //while edit and click logout discard dialog (For Cancel edit)
    isCandProfileEditCancel(iscancel) {
        this.isProfileEditCancel.next(iscancel);
    }

    validateForgotPassCode(data) {
        var body = {
            "password": data.password,
            "username": data.username
        }
        const url1 = environment.SERVER_URL + AppConstants.VALIDATE_CODE;
        return this.http.post(url1, body);
    }
    resetPassword(data) {
        const url1 = environment.SERVER_URL + AppConstants.RESET_PASSWORD;
        return this.http.put(url1, data);
    }

    validateAccessToken() {
        const url = environment.SERVER_URL + AppConstants.VALIDATETOKEN;
        return this.http.get(url);
    }
    duplicationCheckforAts(element) {
        const url = environment.SERVER_URL + AppConstants.DUPLICATION_CHECK_RESUMEATS;
        const headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http
        .get(url, {
          params: element
        })
      }

}
